<style lang="scss">
.system-alert-template .ivu-avatar > * {
  line-height: 50px;
}
</style>
<style lang="scss" scoped>
.app-base-layout {
    padding: 84px 0 60px 0;
}
.avatar-img {
  width: 50px;
  height: 50px;
  border-radius: 100%;
  /* float: left; */
  /* margin-right: 10px; */
}
.image-preview-container {
  height: 150px;
  overflow: hidden;
  text-align: center;
  background: #fff;
  width: 100%;
  margin: 0 auto;
}
.image-preview-container > img {
  height: 100%;
  width: auto;
  margin: 0 auto;
}

.image-preview-container2 {
  height: 130px;
  /* overflow: hidden; */
  text-align: center;
  background: #fff;
  width: 130px;
  margin: 0 auto;
  display: flex;
  .image{
    background-repeat: no-repeat !important;
    background-position: center !important;
    -webkit-background-size: cover !important;
    -moz-background-size: cover !important;
    -o-background-size: cover !important;
    background-size: cover !important;
    width:230px;
    height: 130px;
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;
  }
}
.title {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
}
.call-to-action-content {
  font-size: 12.5px;
  display: -webkit-box;
  -webkit-line-clamp: 10;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.document-content > b {
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        font-size: 1em;
        line-height: 1.3em;
        position: relative;
    }
.document-content {
    width:100%;
    padding: 10px;
}

.section-label{
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    font-size: 0.9em;
    margin-top: 5px;
}
.badge{
    position: absolute;
    bottom: 0;
    right: 0;
    margin: 5px 10px;
    padding: 2px 4px;
    background: #eee;
    border-radius: 25px;
    display: inline-block;
    color: white;
}
    
</style>

<template>
    <div
        class="app-base-layout system-alert-template">
        <div
            v-for="(sharedActivity, i) in shareableActivityList.data"
            :key="i"
            style="margin: 10px 0px; background: #fff;">
            <Row>
                <i-col span="24"
                    @click.native="viewActivity(sharedActivity)">
                    <div v-if="sharedActivity.cover_photo_uri || (sharedActivity.data && sharedActivity.data.preview_image)" 
                        dis-hover 
                        :style="{borderRadius: '0'}"
                        :padding="0" >
                        <div style="display:flex" >
                            <div class="image-preview-container2" style="position:relative">
                            <div v-if="sharedActivity.cover_photo_uri" class="image" :style="{background: 'url('+ postPreviewImage(sharedActivity) +')'}"></div>
                            <div v-else class="image" :style="{background: 'url('+ sharedActivity.data.preview_image +')'}"></div>                  
                            <!-- <Avatar class="avatar-img" style="border:1px solid #ddd" :src="previewAvatar(sharedActivity)" size="large" /> -->
                            </div>
                            <div class="document-content">
                                <b>{{sharedActivity.title}}</b>
                                <p class="section-label block-with-text" v-html="contentDisplay(sharedActivity)"></p>
                                <small style="color:#aaa;font-size:9px">
                                    <timeago :since="sharedActivity.updated_at"></timeago>
                                    <b v-if="section != 'journal' && section != 'group' && sharedActivity.group">
                                    &middot; {{sharedActivity.group.title}}</b>
                                </small>
                                <small
                                    v-if="activityIconStatus(sharedActivity).text != 'none'"
                                    class="badge"
                                    :style="{backgroundColor: activityIconStatus(sharedActivity).color }">
                                    {{ activityIconStatus(sharedActivity).text }}
                                </small>
                            </div>
                        </div>
                    </div>
                    <div v-else dis-hover :style="{borderRadius: '0'}" :padding="0" >
                        <div>
                            <div style="display:flex">
                            <Avatar style="margin:8px; min-height: 40px;min-width: 40px;" v-if="sharedActivity.poster" shape="square" size="large" :src="getDisplayImage(sharedActivity.poster)"/>
                            <b class="section-label" style="word-break: break-word;margin-top:8px">{{sharedActivity.title}}</b>
                            </div>
                            <div style="padding: 0px 10px 10px">
                            <p class="section-label block-with-text" v-html="contentDisplay(sharedActivity)"></p>
                            <small style="color:#aaa;font-size:9px">
                                <timeago :since="sharedActivity.updated_at"></timeago>
                                <b v-if="section != 'journal' && section != 'group' && sharedActivity.group">
                                &middot; {{sharedActivity.group.title}}</b>
                            </small>
                            </div>
                            <small
                                v-if="activityIconStatus(sharedActivity).text != 'none'"
                                class="badge"
                                :style="{backgroundColor: activityIconStatus(sharedActivity).color }">
                                {{ activityIconStatus(sharedActivity).text }}
                            </small>
                        </div>
                    </div>
                </i-col>
            </Row>
        </div>
    </div>
</template>

<script>
    import Utils from '@/utils.js'
    import moment from 'moment'

    export default {
        name: '',
        data() {
            return {
                section: 'none'
            }
        },
        mounted() {
            this.$store.dispatch('systemAlert/getAllShareableActivity')
        },
        computed: {
            shareableActivityList: {
                get() {
                    return this.$store.state.systemAlert.allShareableActivity
                }
            }
        },
        methods: {
            previewAvatar(sharedActivity) {
                if( sharedActivity && sharedActivity.data && sharedActivity.data.opt && sharedActivity.data.opt.avatar ){
                    return process.env.VUE_APP_TEMP + sharedActivity.data.opt.avatar;
                }
                else 
                    return this.tmImg;
            },
            viewActivity (item) {
                if(item.type == "call_to_action" && item.data && item.data.url){
                    window.open(
                    item.data.url,
                    '_blank'
                    );
                }else{
                    // this.$store.commit('systemAlert/setCurrentSystemShown',  this.swiper.activeIndex);
                    this.$store.commit('feed/setSingleFeed', item)
                    this.$router.push({ path: '/feed/' + item.id + "?scroll=false" })
                }
            },
            previewText(sharedActivity) {
                if( sharedActivity )
                return _.get(sharedActivity.data, "opt.message", "We need your help. Please share this post to your Facebook Page.");
                else 
                return "We need your help. Please share this post to your Facebook Page.";
            },
            postPreviewImage (act) {
                if (act.cover_photo && act.cover_photo.length > 0 && 'medium' in act.cover_photo[0]) {
                    return act.cover_photo[0]['medium']
                } else {
                    return Utils.getDisplayImage('user', this.$store.state.user.brand, 'small')
                }
            },
            contentDisplay (act) {
                switch (act.type) {
                    case 'user_post':
                    if (act.data) return act.data.text
                    break
                    case 'passport_expiration':
                    return 'Passport Expiration'
                    break
                    case 'contract_expiration':
                    return 'Contract Expiration'
                    break
                    case 'attachment':
                    if (act.data) {
                        switch (act.data.attachment_type) {
                        case 'video':
                            if (act.data.text || act.data.preview_summary) { return act.data.text || act.data.preview_summary }
                            break
                        case 'link':
                            if (act.data.text || act.data.preview_summary) { return act.data.text || act.data.preview_summary }
                            break
                        default:
                            if (act.data.text) return act.data.text
                            break
                        }
                    }
                    break
                    case 'trivia':
                    if (act.data && act.data.question) return act.data.question
                    break
                    case 'reveal':
                    if (act.data && act.data.question) return act.data.question
                    break
                    case 'recipe':
                    if (act.data && act.data.description) { return '<a>View Recipe</a>' }
                    break
        case 'video': 
          if (act.data && act.data.text) { return act.data.text }
          break
                    case 'call_to_action':
                    if (act.data && act.data.text) {
                        if (act.data.text.includes('$firstname')) return act.data.text.replace('$firstname', this.userInfo.display_name)
                        else return act.data.text.replace(/(<([^>]+)>)/gi, '')
                    }
                    break
                    default:
                    if (act.data && act.data.tip) { return act.data.tip.replace(/(<([^>]+)>)/gi, '') }
                    break
                }
                return ''
            },
            getDisplayImage(user) {
                return Utils.getDisplayImage('user', user, 'small')
            },
            activityIconStatus(item){
                if (Object.keys(item.data).includes('expiration_date') && moment(item.data.expiration_date).isSameOrBefore(moment()))
                    return {
                        text: 'Expired',
                        color: '#26bb2b'
                    } //green
                else {
                    if (item.user_shared.length > 0){
                        if (item.user_shared[0].action === 'skipped')
                            return {
                                text: 'Skipped',
                                color: '#a56868'
                            } //brown
                        else if (item.user_shared[0].action === 'shared')
                            return {
                                text: 'Shared',
                                color: '#4372ff'
                            } //blue
                        else
                            return {
                                text: 'none',
                                color: 'none'
                            }
                    }
                    else
                        return {
                            text: 'none',
                            color: 'none'
                        }
                }
            }
        }
    }
</script>